import { render, staticRenderFns } from "./languageDialog.vue?vue&type=template&id=181c22e1&"
import script from "./languageDialog.vue?vue&type=script&lang=js&"
export * from "./languageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports